import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';

import {DialogTypes} from 'common/names';

import {
   AuditReportParameters,
   IAuditReportParameters,
} from 'types/diplomat/reports/AuditReportParameters';

import {useDownloadPostApi} from 'common/hooks/useDownloadPostApi';
import api from 'api';

import AuditReportForm from './AuditReportForm';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {enums} from 'types/enums';
import {castToSend} from 'common/yup/castToSend';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type Props = {
   onClose: () => void;
   summary?: boolean;
};

const AuditReportDialog: ReactFChildrenProps<Props> = memo(({onClose, summary}) => {
   const {download} = useDownloadPostApi();
   const sendParameters = React.useCallback(
      (values: IAuditReportParameters, bag: FormOnSubmitHelpers<IAuditReportParameters>) => {
         const commonUrl = summary ? api.auditSummary : api.auditReport;
         const url =
            values._format === enums.reportFormats.enum.CSV ? commonUrl + 'csv' : commonUrl;

         download(url, JSON.stringify(castToSend(AuditReportParameters, values)), {
            onSuccess: () => bag.setSubmitting(false),
            onFailure: (errors: any) => {
               bag.setSubmitting(false);
               bag.setErrors(errors);
            },
         });
      },
      [download, summary]
   );

   return (
      <DialogComponent
         maxWidth="lg"
         header={DialogTypes.AuditReportDialog.dialogName}
         close={onClose}
      >
         <AuditReportForm onSubmit={sendParameters} onClose={onClose} />
      </DialogComponent>
   );
});

export default AuditReportDialog;
